import { RadioOnFill } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';
import { useState } from 'react';

import * as S from './style';

type SelectorProps = {
  values: string[];
  selectedValue: string;
  onClickItem: (value: string) => void;
};

const Selector = ({ values, selectedValue, onClickItem }: SelectorProps) => {
  return (
    <div>
      {values.map((value) => (
        <SelectItem
          key={value}
          value={value}
          isSelected={value === selectedValue}
          onClick={onClickItem}
        />
      ))}
    </div>
  );
};
export default Selector;

type SelectItemProps = {
  value: string;
  isSelected: boolean;
  onClick: (value: string) => void;
};

function SelectItem({ value, isSelected, onClick }: SelectItemProps) {
  const [isHover, setIsHover] = useState(false);
  return (
    <S.Option
      className={isSelected ? 'clicked' : ''}
      onClick={() => onClick(value)}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <RadioOnFill
        size={24}
        primaryColor={isSelected ? vars.brand.default : vars.neutral[40]}
        secondaryColor={
          isSelected ? vars.brand.default : isHover ? vars.neutral[40] : 'none'
        }
      />
      {value}
    </S.Option>
  );
}
